import React from 'react';
import { Typography } from 'antd';

const { Title, Text, Link, Paragraph } = Typography;

export default function CustomTypography({ type, children, ...props }) {
    switch (type) {
        case 'title':
            return <Title {...props}>{children}</Title>;
        case 'text':
            return <Text {...props}>{children}</Text>;
        case 'link':
            return <Link {...props}>{children}</Link>;
        case 'paragraph':
            return <Paragraph {...props}>{children}</Paragraph>;
        default:
            return <Text {...props}>{children}</Text>;
    }
};

